const CHARSETS = {
    upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lower: 'abcdefghijklmnopqrstuvwxyz',
    number: '0123456789',
    special: '!@#$%^&*()-_=+[]{}|;:,.<>?'
};

function secureRandom(max) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0] % max;
}

function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = secureRandom(i + 1);
        [array[i], array[j]] = [array[j], array[i]];
    }
}

window.generatePassword = function () {

    const selectedSets = [];

    Object.entries(CHARSETS).forEach(([id, chars]) => {
        const element = document.getElementById(id);

        if (element && element.checked) {
            selectedSets.push(chars);
        }
    });

    if (!selectedSets.length) {
        alert('Please select at least one character set.');
        return;
    }

    const lengthField = document.getElementById('passLength');

    if (!lengthField) {
        return;
    }

    const length = parseInt(lengthField.value, 10);

    let password = [];

    // Ensure at least one character from each selected set
    selectedSets.forEach(set => {
        password.push(
            set[secureRandom(set.length)]
        );
    });

    const allChars = selectedSets.join('');

    while (password.length < length) {
        password.push(
            allChars[secureRandom(allChars.length)]
        );
    }

    shuffle(password);

    const passwordField = document.getElementById('password');

    if (passwordField) {
        passwordField.value = password.join('');
    }
};

window.copyPassword = async function () {

    const passwordField = document.getElementById('password');

    if (!passwordField || !passwordField.value) {
        return;
    }

    try {
        await navigator.clipboard.writeText(passwordField.value);

        const button = document.getElementById('copyPass');

        if (button) {
            const originalText = button.innerText;

            button.innerText = '✓ Copied';

            setTimeout(() => {
                button.innerText = originalText;
            }, 2000);
        }
    } catch (error) {
        console.error('Copy failed:', error);
    }
};

document.addEventListener('DOMContentLoaded', () => {

    if (
        document.getElementById('password') &&
        document.getElementById('passLength')
    ) {
        generatePassword();
    }

});